'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/syntax.js
// module id = 263
// module chunks = 8